// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_ge","advertDetailService__price":"c-p_gf"};